<template>
  <ZigzagServiceLayout
    mainTitle="General Primary Care Services"
    mainDescription="From children to adults, our bilingual team is here to provide accessible, personalized care for every stage of life."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'PrimaryContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'PRIMARY CARE',
          title: 'Prevention & Wellness',
          subtitle: 'Regular visits to stay ahead of health issues.',
          paragraphs: [
            "Routine checkups and preventive care are essential for maintaining optimal health.",
            "We offer complete evaluations to track your overall health, vaccinations to protect children and adults at every stage, and required school physicals to keep kids safe."
          ],
          list: [
            "Annual physical exams",
            "Wellness visits with personalized plans",
            "Vaccinations & immunizations",
            "School physicals"
          ],
          image: '/images/services/primary-prevention.png'
        },
        {
          label: 'CHRONIC CARE',
          title: 'Condition Management',
          subtitle: 'Long-term support for your health conditions.',
          paragraphs: [
            "We provide ongoing monitoring and treatment to control chronic issues like diabetes and hypertension.",
            "Our personalized care plans aim to reduce cardiovascular risk, manage thyroid disorders, and support safe, supervised weight management."
          ],
          list: [
            "Diabetes management",
            "Hypertension & High cholesterol control",
            "Thyroid disorders",
            "Obesity & weight management"
          ],
          image: '/images/services/primary-chronic.png'
        },
        {
          label: 'SPECIALIZED CARE',
          title: 'Health Screenings & Acute Care',
          subtitle: 'Early detection and quick relief.',
          paragraphs: [
            "Early detection saves lives; we offer comprehensive health screenings for blood pressure, cholesterol, and diabetes.",
            "Additionally, we provide fast relief for colds, the flu, and minor injuries, alongside tailored treatments for allergies and migraines."
          ],
          list: [
            "Health screenings for early detection",
            "Acute care & sick visits",
            "Minor injuries & wound care",
            "Treatment for headaches & allergies"
          ],
          image: '/images/services/primary-specialized.png'
        },
        {
          label: 'Holistic CARE',
          title: "Men's, Women's, & Mental Health",
          subtitle: 'Comprehensive support tailored to you.',
          paragraphs: [
            "We supply routine and preventive care for all stages of a woman's and man's life, from birth control counseling to medical testosterone therapy.",
            "Furthermore, we offer holistic behavioral care for anxiety, depression, and ADHD."
          ],
          list: [
            "Women's exams, PCOS & Menopause management",
            "Men's screening, ED & TRT",
            "Mental health & anxiety management",
            "Minor procedures: cyst removal & ear lobe repair"
          ],
          image: '/images/weight-loss/img-principal-new.webp'
        }
      ]
    };
  }
};
</script>
